import React, { useState, useRef } from 'react';
import './Seminar.css';

const Seminar: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = () => {
    setIsPlaying(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 100);
  };

  return (
    <section className="seminar-section">
      <div className="seminar-container">
        {/* Text Content */}
        <div className="seminar-info">
          <p className="seminar-badge">Seminer</p>
          <h2 className="seminar-title">Şefkat Atölyesi</h2>
          <p className="seminar-description">
            Uzman Klinik Psikolog <strong>Sinem Yetkin</strong> tarafından velilerimize yönelik
            düzenlenen Şefkat Atölyesi seminerimiz. Çocuklarımızın duygusal gelişimini desteklemek
            ve aile içi iletişimi güçlendirmek amacıyla gerçekleştirilen bu özel etkinlikte,
            şefkat ve empati konuları ele alınmıştır.
          </p>
          <div className="seminar-details">
            <div className="seminar-detail-item">
              <i className="fa-solid fa-user-tie"></i>
              <span>Sinem Yetkin - Uzm. Klinik Psikolog</span>
            </div>
            <div className="seminar-detail-item">
              <i className="fa-solid fa-heart"></i>
              <span>Şefkat, Empati ve Aile İçi İletişim</span>
            </div>
          </div>
        </div>

        {/* Video */}
        <div className="seminar-video-wrapper">
          <div className="seminar-video-container">
            {!isPlaying ? (
              <div className="seminar-thumbnail" onClick={handlePlay}>
                <img
                  src="/images/seminer-thumbnail.jpg"
                  alt="Şefkat Atölyesi - Sinem Yetkin"
                  loading="lazy"
                />
                <div className="seminar-play-overlay">
                  <div className="seminar-play-button">
                    <i className="fa-solid fa-play"></i>
                  </div>
                  <p className="seminar-play-text">Semineri İzle</p>
                </div>
              </div>
            ) : (
              <video
                ref={videoRef}
                controls
                playsInline
                className="seminar-video"
              >
                <source src="/videos/sefkat-atolyesi.mp4" type="video/mp4" />
                Tarayıcınız video oynatmayı desteklemiyor.
              </video>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Seminar;
